// extracted by mini-css-extract-plugin
export default {"background":"Backdrop_background__mTpt9"};